import 'components/util/ez-file-drag-drop/ez-file-drag-drop.css';
import 'components/search/search-by-image/search-by-image.css';

import SearchByImageController from 'components/search/search-by-image/search-by-image-controller';
import SearchByImageDragDropController from 'components/search/search-by-image/search-by-image-drag-drop-controller';

window.EezyStimulusApplication.register('search-by-image', SearchByImageController);
window.EezyStimulusApplication.register('search-by-image-drag-drop', SearchByImageDragDropController);
